import CHECKOUT_GETTER_TYPES from './checkout-getter-types'
import CUSTOMER_GETTER_TYPES from './customer-getter-types'
import SERVICE_GETTER_TYPES from './service-getter-types'
import ORDER_GETTER_TYPES from './order-getter-types'

export default {
  ...CHECKOUT_GETTER_TYPES,
  ...CUSTOMER_GETTER_TYPES,
  ...SERVICE_GETTER_TYPES,
  ...ORDER_GETTER_TYPES,

  META: 'META',

  // Options
  OPTIONS_PROMISE: 'OPTIONS_PROMISE',
  OPTIONS_DATA: 'OPTIONS_DATA',
  OPTIONS_CONTENT_BASEURL: 'OPTIONS_CONTENT_BASEURL',
  OPTIONS_ATTRIBUTE_URL: 'OPTIONS_ATTRIBUTE_URL',
  OPTIONS_BASKET_URL: 'OPTIONS_BASKET_URL',
  OPTIONS_BASKET_URL_PROMISE: 'OPTIONS_BASKET_URL_PROMISE',
  OPTIONS_CATALOG_URL: 'OPTIONS_CATALOG_URL',
  OPTIONS_CUSTOMER_URL: 'OPTIONS_CUSTOMER_URL',
  OPTIONS_LOCALE_URL: 'OPTIONS_LOCALE_URL',
  OPTIONS_ORDER_URL: 'OPTIONS_ORDER_URL',
  OPTIONS_PRODUCT_URL: 'OPTIONS_PRODUCT_URL',
  OPTIONS_SPAREPARTS_URL: 'OPTIONS_SPAREPARTS_URL',
  OPTIONS_SKUS_URL: 'OPTIONS_SKUS_URL',
  PROMISE_OPTIONS_PRODUCT_URL: 'PROMISE_OPTIONS_PRODUCT_URL',
  OPTIONS_SERVICE_URL: 'OPTIONS_SERVICE_URL',
  OPTIONS_STOCK_URL: 'OPTIONS_STOCK_URL',
  OPTIONS_SUPPLIER_URL: 'OPTIONS_SUPPLIER_URL',
  OPTIONS_FAVORITE_URL: 'OPTIONS_FAVORITE_URL',
  OPTIONS_COMPARE_URL: 'OPTIONS_COMPARE_URL',
  GET_OPTIONS_PROMISE_URL: 'GET_OPTIONS_PROMISE_URL',

  // BASKET
  BASKET: 'BASKET',
  BASKET_PROMISE: 'BASKET_PROMISE',
  BASKET_REQUEST_COUNT: 'BASKET_REQUEST_COUNT',
  BASKET_PRICE: 'BASKET_PRICE',
  BASKET_COUNT: 'BASKET_COUNT',
  BASKET_CURRENCYID: 'BASKET_CURRENCYID',
  // BASKET_PRICE_FORMATTER: 'BASKET_PRICE_FORMATTER',
  BASKET_BASE_ID: 'BASKET_BASE_ID',
  // BASKET_PRODUCT_RELATIONSHIPS: 'BASKET_PRODUCT_RELATIONSHIPS',
  BASKET_INCLUDED: 'BASKET_INCLUDED',
  // BASKET_PRODUCT_INCLUDED: 'BASKET_PRODUCT_INCLUDED',
  // BASKET_BIKE_INCLUDED: 'BASKET_BIKE_INCLUDED',
  // BASKET_BIKE_GROUPED: 'BASKET_BIKE_GROUPED',
  // BASKET_SPAREPART_GROUPED: 'BASKET_SPAREPART_GROUPED',
  // BASKET_SPAREPART_INCLUDED: 'BASKET_SPAREPART_INCLUDED',
  BASKET_CLIENTS: 'BASKET_CLIENTS',
  BASKET_CLIENT_DELIVERY_ADDRESSES: 'BASKET_CLIENT_DELIVERY_ADDRESSES',
  BASKET_CLIENT_PRODUCTS_GROUPED: 'BASKET_CLIENT_PRODUCTS_GROUPED',
  // BASKET_ADDRESS_INCLUDED: 'BASKET_ADDRESS_INCLUDED',
  // BASKET_SERVICE_INCLUDED: 'BASKET_SERVICE_INCLUDED',
  BASKET_CLIENT_DATA: 'BASKET_CLIENT_DATA',
  BASKET_CLIENT_DATA_FOR: 'BASKET_CLIENT_DATA_FOR',
  BASKET_PAYMENT_ADDRESS_INCLUDED: 'BASKET_PAYMENT_ADDRESS_INCLUDED',
  BASKET_DELIVERY_ADDRESS_INCLUDED: 'BASKET_DELIVERY_ADDRESS_INCLUDED',
  BASKET_PAYMENT_SERVICE_INCLUDED: 'BASKET_PAYMENT_SERVICE_INCLUDED',
  BASKET_DELIVERY_SERVICE_INCLUDED: 'BASKET_DELIVERY_SERVICE_INCLUDED',
  BASKET_LINKS: 'BASKET_LINKS',
  DATA_BASKET_LINKS: 'DATA_BASKET_LINKS',
  BASKET_BASKET_ORDER_POST_URL: 'BASKET_BASKET_ORDER_POST_URL',
  BASKET_BASKET_SELF_POST_URL: 'BASKET_BASKET_SELF_POST_URL',
  BASKET_BASKET_SELF_PATCH_URL: 'BASKET_BASKET_SELF_PATCH_URL',
  BASKET_BASKET_PRODUCT_POST_URL: 'BASKET_BASKET_PRODUCT_POST_URL',
  BASKET_BASKET_ADDRESS_POST_URL: 'BASKET_BASKET_ADDRESS_POST_URL',
  BASKET_BASKET_ADDRESS_DELETE_URL: 'BASKET_BASKET_ADDRESS_DELETE_URL',
  BASKET_BASKET_PAYMENT_ADDRESS_DELETE_URL: 'BASKET_BASKET_PAYMENT_ADDRESS_DELETE_URL',
  BASKET_BASKET_DELIVERY_ADDRESS_DELETE_URL: 'BASKET_BASKET_DELIVERY_ADDRESS_DELETE_URL',
  BASKET_BASKET_SERVICE_POST_URL: 'BASKET_BASKET_SERVICE_POST_URL',
  BASKET_BASKET_PAYMENT_SERVICE_DELETE_URL: 'BASKET_BASKET_PAYMENT_SERVICE_DELETE_URL',
  BASKET_BASKET_DELIVERY_SERVICE_DELETE_URL: 'BASKET_BASKET_DELIVERY_SERVICE_DELETE_URL',
  BASKET_REFERENCE: 'BASKET_REFERENCE',
  BASKET_COMMENT: 'BASKET_COMMENT',
  BASKET_DELIVERY_IS_BILLING_ADDRESS: 'BASKET_DELIVERY_IS_BILLING_ADDRESS',
  BASKET_PAYMENT_ADDRESS: 'BASKET_PAYMENT_ADDRESS',
  BASKET_DELIVERY_ADDRESS: 'BASKET_DELIVERY_ADDRESS',
  BASKET_DELIVERY_ADDRESS_ID: 'BASKET_DELIVERY_ADDRESS_ID',
  BASKET_DELIVERY_ADDRESS_FORMATTED: 'BASKET_DELIVERY_ADDRESS_FORMATTED',
  BASKET_PAYMENT_SERVICE_ID: 'BASKET_PAYMENT_SERVICE_ID',
  BASKET_DELIVERY_SERVICE_ID: 'BASKET_DELIVERY_SERVICE_ID',
  BASKET_BIKE_PRICE: 'BASKET_BIKE_PRICE',
  BASKET_SPAREPART_PRICE: 'BASKET_SPAREPART_PRICE',

  // CHECKOUT
  CHECKOUT_ADDITONALINFO_BASKET: 'CHECKOUT_ADDITONALINFO_BASKET',
  CHECKOUT_CREATE_ORDER_DATA: 'CHECKOUT_CREATE_ORDER_DATA',

  // SEARCH
  SEARCH_DATA: 'SEARCH_DATA',
  SEARCH_PENDING: 'SEARCH_PENDING',
  SEARCH_ATTRIBUTE_COUNTS: 'SEARCH_ATTRIBUTE_COUNTS',
  SEARCH_CATEGORY_COUNTS: 'SEARCH_CATEGORY_COUNTS',

  // PRODUCTS
  PRODUCTS_PROMISE: 'PRODUCTS_PROMISE',
  PRODUCTS_DATA: 'PRODUCTS_DATA',
  PRODUCT_PROMISE: 'PRODUCT_PROMISE',
  PRODUCT_DATA: 'PRODUCT_DATA',
  PRODUCT_MESSAGE: 'PRODUCT_MESSAGE',

  // BLOCKINGREASONS
  BLOCKINGREASONS_PROMISE: 'BLOCKINGREASONS_PROMISE',
  BLOCKINGREASONS_PENDING: 'BLOCKINGREASONS_PENDING',
  BLOCKINGREASONS_DATA: 'BLOCKINGREASONS_DATA',
  BLOCKINGREASONS_LIST: 'BLOCKINGREASONS_LIST',
  ADDRESSES_WITH_BLOCKINGREASONS: 'ADDRESSES_WITH_BLOCKINGREASONS',

  // PRODUCTSPAREPARTS
  PRODUCTSPAREPARTS_PROMISE: 'PRODUCTSPAREPARTS_PROMISE',
  PRODUCTSPAREPARTS_DATA: 'PRODUCTSPAREPARTS_DATA',
  PRODUCTSPAREPARTS_MESSAGE: 'PRODUCTSPAREPARTS_MESSAGE',

  // CUSTOMER
  CUSTOMER_PROMISE: 'CUSTOMER_PROMISE',
  CUSTOMER_STATE: 'CUSTOMER_STATE',

  // CLIENT
  CLIENT_INORMATION: 'CLIENT_INORMATION',
  CLIENT_INORMATION_UNIQUE: 'CLIENT_INORMATION_UNIQUE',
  CLIENT_INORMATION_UNIQUE_CHECKED: 'CLIENT_INORMATION_UNIQUE_CHECKED',
  CLIENT_ARRAY: 'CLIENT_ARRAY',

  // FAVORITE
  FAVORITE_PENDING: 'FAVORITE_PENDING',
  // FAVORITE_PRODUCT_ID_TO_RELATEDID: 'FAVORITE_PRODUCT_ID_TO_RELATEDID',
  FAVORITE_SKU_TO_RELATEDID: 'FAVORITE_SKU_TO_RELATEDID',
  FAVORITE_PRODUCT_ID_TO_SKU: 'FAVORITE_PRODUCT_ID_TO_SKU',
  // FAVORITE_PRODUCT_IDS: 'FAVORITE_PRODUCT_IDS'
  FAVORITE_PRODUCT_AND_PARENTS_SKUS: 'FAVORITE_PRODUCT_AND_PARENTS_SKUS',
  FAVORITE_PRODUCT_SKUS: 'FAVORITE_PRODUCT_SKUS',
  FAVORITE_PRODUCT_URL: 'FAVORITE_PRODUCT_URL',
  FAVORITE_VARIANT_SKUS: 'FAVORITE_VARIANT_SKUS',
  FAVORITE_SKU_AVAILABILITIES: 'FAVORITE_SKU_AVAILABILITIES',
  FAVORITE_SKU_AVAILABILITY_GROUPS: 'FAVORITE_SKU_AVAILABILITY_GROUPS',
  FAVORITE_FILTER_DATA: 'FAVORITE_FILTER_DATA',
  FAVORITE_COUNT: 'FAVORITE_COUNT',

  // FAVORITEPRODUCTS
  FAVORITEPRODUCTS_PENDING: 'FAVORITEPRODUCTS_PENDING',
  FAVORITEPRODUCTS_FAILED: 'FAVORITEPRODUCTS_FAILED',
  FAVORITEPRODUCTS_DATA: 'FAVORITEPRODUCTS_DATA',
  FAVORITEPRODUCTS_COUNT: 'FAVORITEPRODUCTS_COUNT',
  FAVORITEPRODUCTS_DATA_WITH_CONFIG_OBJECT: 'FAVORITEPRODUCTS_DATA_WITH_CONFIG_OBJECT',
  FAVORITEPRODUCTS_DATA_WITH_FAVORITE_DATA: 'FAVORITEPRODUCTS_DATA_WITH_FAVORITE_DATA',
  FAVORITEPRODUCTS_DATA_WITH_FAVORITE_DATA_SORTED:
    'FAVORITEPRODUCTS_DATA_WITH_FAVORITE_DATA_SORTED',
  FAVORITEPRODUCTS_DATA_WITH_FAVORITE_DATA_SORTED_COUNT:
    'FAVORITEPRODUCTS_DATA_WITH_FAVORITE_DATA_SORTED_COUNT',

  //COMPARE
  COMPARE_PENDING: ' COMPARE_PENDING',
  COMPARE_FAILED: 'COMPARE_FAILED',
  COMPARE_PRODUCT_IDS: ' COMPARE_PRODUCT_IDS',
  COMPARE_COUNT: ' COMPARE_COUNT',
  COMPARE_DATA: 'COMPARE_DATA',
  COMPARE_DATA_RAW: 'COMPARE_DATA_RAW',

  // PRODUCTATTRIBUTES
  PRODUCTATTRIBUTES_PENDING: 'PRODUCTATTRIBUTES_PENDING',
  PRODUCTATTRIBUTES_FAILED: 'PRODUCTATTRIBUTES_FAILED',
  PRODUCTATTRIBUTES_DATA: 'PRODUCTATTRIBUTES_DATA',

  // AVAILABILITY WATCH
  AVAILABILITYWATCH_PENDING: 'AVAILABILITYWATCH_PENDING',
  AVAILABILITYWATCH_IS_SKU_ON_LIST: 'AVAILABILITYWATCH_IS_SKU_ON_LIST',
}
